<template>
	<div class="report_container full" v-loading="loading">
		<el-container class="full">
			<el-main class="main flex">
				<vxe-grid v-if="list_gridOptions" ref="sourcebill" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
				<pushdata-form :data="currentrow" ref="pushdataForm" @submit="pushdataFormSubmit" @modalhide="sourcebillHide" />
				<pushdata-detail :data="currentrow" ref="pushdataDetail"  />
			</el-main>
		</el-container>
	</div>
</template>
<style>

</style>
<style scoped>
	.head {
		padding: 10px 0;
		border-bottom: 1px solid rgb(220, 223, 230);
	}
	
	.aside {
		border-right: 1px solid rgb(220, 223, 230);
		box-sizing: border-box;
		padding-bottom: 100px;
	}
	
	.main {
		position: relative;
		width: 100%;
		height: 100%;
		padding: 5px;
		box-sizing: border-box;
		flex-direction: column;
		overflow: hidden;
	
	}
	.group {
		margin: 10px 0px;
		width: 100%;
		margin-left: 10px;
	}
</style>
<script>
	
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import pushdataForm from '../../lib/pushdata/tradeback/form'
	import pushdataDetail from '../../lib/pushdata/tradeback/detail'
	export default {
		mixins: [listMixins],
		name: 'report',
		props: {
			fundtype: {
				default: () => {
					return 'CD'
				}
			},
			bancktype: {
				default: () => {
					return ''
				}
			},			
		},
		data() {
			return {
				loading:false,
				foreingKey:{},
				currentrow:{},
				list_formConfig: [{
					field: 'biztime',
					title: '账单月份',
					span: 4,
					itemRender: {
						name: '$datePicker',
						props:{
							type:"month"
						}
					}
				}]
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},
		methods: {
			list(page,updateForm,other) {
				// console.log(page,updateForm,other)
				return new Promise(resolve => {
					this.$api.pushdata.list({
						...{local_model:"tradeback"},
						...page,
						...updateForm,
						...other,
					}).then((res)=>{
						resolve(res)
					},()=>{
						this.loading = false
					})
				})

				
				// return new Promise(resolve => {
				// 	this.$api.report.reportlist(this.reportName,{
				// 		...page,
				// 		...updateForm,
				// 		...other,
				// 		...this.foreingKey,
				// 		...{
				// 			fundtype:this.fundtype,
				// 			bancktype:this.bancktype,
				// 		}
				// 	}).then((res) => {
				// 		this.sourcedata = JSON.parse(JSON.stringify(res.list))
				// 		if (this.afterGet) {
				// 			this.afterGet(res,updateForm)
				// 		}
				// 		resolve(res)
				// 	}, () => {
				// 		resolve([])
				// 	})
				// })
			},		
			list_beforeCreateGrid(gridOptions){
				gridOptions.id = 'pushdatatradeback_list'
				gridOptions.pagerConfig = {
					enabled: true,
					autoHidden: false,
					border: true,
					size: 'mini',
					perfect: false,
					currentPage: 1,
					pageSize: 20,
					pageSizes: [10, 20, 50,2000,5000],
				}
				gridOptions.columns = [	
					{
						field: 'biztime',
						title: '账单月份',
						formatter: ({
							cellValue
						}) => {
							return window.systemMethods.timestampToDate(cellValue, 'month')
						},
					},	
					{field:'local_model',title:'本地模块',props:{show:true}},
					{field:'target_model',title:'目标模块',props:{show:true}},	
					{field:'mark',title:'备注',render:'',props:{show:true}},			
					{
						field: 'status',
						title: '状态',
						width:100,
						fixed:"right",
						slots: {
							default: ({row}) => {
								if(row.status == 1){
									return '已同步'
								}else if(row.status == 0){
									return '未同步'
								}else{
									return '部分同步'
								}
							}
						},
						visible:true
					},		
					{
						field: 'create_time',
						title: '创建时间',
						formatter: ({
							cellValue
						}) => {
							return window.systemMethods.timestampToDate(cellValue, true)
						},
					},													
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 160,
						slots: {
							default: ({row}) => {
								return [
									<el-button type = "text" size = "mini" onClick = {() => {this.detail(row)}}>明细</el-button>,
									<el-button type = "text" size = "mini" onClick = {() => {this.uploadjindie(row)}}>同步金蝶</el-button>,
									<el-button type = "text" size = "mini" onClick = {() => {this.del(row)}}>删除</el-button>
								]
							}
						}
					}
				]
				gridOptions.checkboxConfig = null
				
				gridOptions.toolbarConfig.buttons = [{
					name: '新增',
					status: 'primary',
					code: 'add'
				}]
			},
			add(){
				this.currentrow = {
					local_model:"tradeback",
					target_model:"SAL_RETURNSTOCK",
				}
				this.$refs.pushdataForm.modal_show()
			},
			detail(row){
				this.currentrow = row
				this.$nextTick(()=>{
					this.$refs.pushdataDetail.modal_show()
				})
			},
			del(row){
				this.$confirm('是否确认删除' , '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true
					this.$api.pushdata.delete(row.id).then(()=>{
						this.loading = false
						this.customreload()
					},()=>{
						this.loading = false
					})
				}).catch(() => {
					this.loading = false
				})				
			},
			uploadjindie(row) {
				this.$confirm('是否确认同步 ' + (row.code ? row.code : ''), '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true
					this.$api.pushdata.uploadjindie({
						id: row.id
					}).then(() => {
						this.loading = false
						this.$message.success('操作成功')
						this.customreload()
					}, () => {
						this.loading = false
					})
				}).catch(() => {
					this.loading = false
				})
			
			},
			pushdataFormSubmit(){
				this.customreload()
			},
			sourcebillHide(){
				this.currentrow = {}
			},
			customreload(){
				this.$refs.sourcebill.commitProxy('query')
			},
		},
		components: {
			pushdataForm,
			pushdataDetail
		}
	}
</script>